import _ from 'lodash';

import worldMap from '../../core/map';
import { pinBuilder } from '../../core/map/pinBuilder';
import templates from '../../core/templates';
import ColorBrewer from '../../core/tools/colorbrewer';
import environment from '../../environment';
import { notify, NOTIFY_TYPE } from '../../shared/notify';
import Leaflet from '../Leaflet';
import translate from '../../core/tools/translate';
import filters from '../../core/filters';
import store from '../../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../../store/modules/overview-panel/types';

const LayerControls = (name) => require('../../controls').get(name);

const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('../index').default.get(name, currentMap);
};

const name = 'CompanyCustomersPotentialAfterSales';

class CompanyCustomersPotentialAfterSalesLayer {
    constructor(currentMap) {
        const mapId = currentMap._id;
        this.layer = new Leaflet.D3Layer();

        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_customers.png`;

        const colors = {
            blue: 'rgba(30, 136, 229, 1)',
            red: 'rgba(229, 57, 53, 1)',
            green: 'rgba(67, 160, 71, 1)',
            cyan: 'rgba(0, 172, 193, 1)',
            pink: 'rgba(216, 27, 96, 1)',
            orange: 'rgba(255, 102, 0, 1)',
            lime: 'rgba(192, 202, 51, 1)',
            yellow: 'rgba(255, 193, 7, 1)',
            purple: 'rgba(103, 58, 183, 1)',
            teal: 'rgba(0, 137, 123, 1)'
        };

        const getUniqValues = (values) => {
            if (values.length === 0) {
                return [];
            }

            return values.reduce((acc, curr) => {
                if (!acc.some(x => x.value === curr.value)) {
                    acc.push(curr);
                }
                return acc;
            }, []);
        };

        const clusterTemplate = (cluster) => {
            const data = {
                percent: [],
                colors: [],
                value: cluster.getChildCount()
            };

            let total = 0;
            const categories = {};

            const values = getUniqValues(get(name, currentMap).options.symbology.values);
            const order = _.map(_.range(0, values.length), i => 0);

            _.forEach(values, (v, i) => {
                order[i] = v.value;
                data.colors.push(colors[v.style.color]);
            });

            _.forEach(cluster.getAllChildMarkers(), (marker) => {
                if (marker.feature) {
                    total++;
                    const prop = marker.feature.properties.ClientCompanyTypeName;
                    categories[prop] = categories[prop] + 1 || 1;
                }
            });

            if (total > 0) {
                _.forEach(order, id => data.percent.push(((categories[id] || 0) / total) || 0));
            }

            return pinBuilder.create.pin.imageWithValue(data, clusterImage);
        };

        const onSuccess = (res) => {
            if (!res.features.length) {
                notify(NOTIFY_TYPE.LOG, 'Não há dados para o período selecionado');
            }
            return res;
        };

        const onComplete = (res) => {
            LayerControls(name)._setStoreIcon(res);
            const layerType = LayerControls(name).getControls(mapId).buttonGroup.layerType.type;

            if (layerType !== 'heat') {
                const zoomActually = worldMap.getZoom();
                worldMap.setZoom(zoomActually + 0.000001);
            if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === name && store.getters[OVERVIEW_PANEL_IS_VISIBLE] && LayerControls(name).getControls(mapId).button.overview.enable) {
                LayerControls(name).toggleOverview();
            }
            }
        };

        const date = environment.get("CONFIG.FILTERS.CLIENT_COMPANY_PERIOD");

        this.layer.setOptions({
            map: currentMap,
            remote: {
                method: 'POST',
                url: `${environment.get("API_HOST")}/aftersales/customers/companycustomerspotential`,
                params: {
                    MonthInitial: date.monthInitial,
                    MonthEnd: date.monthEnd,
                    YearInitial: date.yearInitial,
                    YearEnd: date.yearEnd,
                },
            },
            showAll: false,
            autofocus: true,
            uniqueField: 'Id',
            scaleRange: [8, 20],
            controlRange: 30,
            incremental: true,
            type: 'cluster',
            above: true,
            done: onComplete,
            success: onSuccess,
            popup: {
                trigger: 'mouseover',
                clusterTemplate(features, layer) {
                    if (worldMap.getZoom() < 6) return;

                    const layerType = LayerControls(name).getControls(mapId).buttonGroup.layerType.type;
                    if (layerType === 'decluster') {
                        this.options.offset = L.point(0, 0);
                    } else {
                        this.options.offset = L.point(0, -50);
                    }
                    return new Promise((resolve, reject) => {

                        const total = _.size(features);

                        const data = _(features)
                            .groupBy('feature.properties.ClientCompanyTypeName')
                            .map((v, k) => {
                                const style = _.find(get(name, currentMap).options.symbology.values, (s) => String(s.value) === k).style;
                                const text = _.first(v).feature.properties.ClientCompanyTypeName;
                                return {
                                    id: k,
                                    value: _.size(v),
                                    percent: _.size(v) / total,
                                    text,
                                    color: colors[style.color]
                                };
                            })
                            .orderBy(x => x.percent)
                            .reverse()
                            .reduce((res, val, index) => {
                                res.push(val);
                                return res;
                            }, []);

                        const template = $(templates('map-layer-clients-cluster-popup-alt', ({ clients: data })));

                        setTimeout(() => {
                            $('#map-popup-chart').kendoChart({
                                title: {
                                    text: ''
                                },
                                dataSource: { data: _.filter(data, d => parseFloat(d.value) > 0) },
                                seriesColors: _.map(data, d => d.color),
                                seriesDefaults: {
                                    labels: {
                                        position: 'center',
                                        visible: true,
                                        background: 'transparent',
                                        format: '{0}',
                                        font: 'bold 10px "Roboto Condensed", sans-serif',
                                        color: '#FFF'
                                    }
                                },
                                theme: 'bootstrap',
                                chartArea: {
                                    height: 140,
                                },
                                legend: {
                                    position: 'right',
                                    labels: {
                                        font: '10px "Roboto Condensed", sans-serif'
                                    }
                                },
                                series: [{
                                    type: 'pie',
                                    field: 'value',
                                    categoryField: 'text'
                                }]
                            });
                        }, 300);

                        resolve(template);
                    });
                },
                options: {
                    offset: L.point(0, 0),
                    closeButton: false,
                    autoclose: true
                },
                single: true
            },
            legend: {
                title: translate('Common.CompanyCustomersPotentialAfterSales'),
                text: (property) => {
                    return property.ClientCompanyTypeName;
                },
                icon: (property) => {
                    const values = get(name, currentMap).options.symbology.values;
                    const store = _.find(values, p => p.value === property.ClientCompanyTypeName);
                    return store && store.style.icon.iconUrl;
                },
            },
            symbology: {
                type: 'uniq',
                property: 'ClientCompanyTypeName',
                cluster: {
                    template: clusterTemplate
                },
                heat: {
                    theme: ColorBrewer.getHeatColors(ColorBrewer.RED),
                },
                style: {
                    icon: {
                        fields: ['ClientCompanyName'],
                    },
                    riseOnHover: true,
                },
                values: [],
            }
        });

        return this.layer;
    }
}

export default CompanyCustomersPotentialAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/CompanyCustomersPotentialAfterSalesLayer.js